export default function SimilarActivity(data) {
  this.id = data.id
  this.similarity = data.score
  this.isDuplicate = data.is_duplicate
  this.name = data.name
  this.professions = data.professions || []
}
